import * as tool from "./_tools.js";

let ville = "";
let cp = "";

let preUrl = window.location.origin;

/**
 * Constructor for creating a new instance of the class.
 *
 * @param {type} commune - description of the commune parameter
 * @param {type} formField - description of the formField parameter
 * @param {type} submit - description of the submit parameter
 * @return {type}
 */
class StoreLocatorSearch {
    constructor(commune, formField, submit) {
        this.commune = commune;
        this.formField = formField;
        this.submit = submit;
        this.init().then(r => r);
    }

    async init() {
        try {
            let data = await this.searchCommuneHome();
            this.updateCommuneList(data.data);
        } catch (error) {
            console.error("Error:", error);
        }
    }

    async searchCommuneHome() {
        const inputList = document.querySelector(".input-city");
        if (!window.location.pathname.includes('/formulaire-contact/')) {
            inputList.style.backgroundImage = "none";
        }

        let list = this.formField.nextElementSibling;
        if (window.location.pathname.includes('/formulaire-contact/')) {
            list = document.querySelector("#city");
            if (list) {
                let option = document.createElement("option");
                option.classList.add("list");
                option.classList.add("input-city");
                list.appendChild(option);
                option.innerHTML = "";
                option.appendChild(this.createLoadingOption())
            }
        } else {
            if (list === null) {
                list = document.createElement("ul");
                list.classList.add("list");
                list.classList.add("input-city");
                this.formField.parentNode.appendChild(list);
            }
            list.innerHTML = "";
            list.appendChild(this.createLoadingOption());
        }
        try {
            const response = await tool.makeRequest(
                ajaxUrl,
                "POST",
                "getCommunesByCp",
                {commune: this.commune}
            );
            return JSON.parse(response);
        } catch (error) {
            throw error;
        }
    }

    updateCommuneList(data) {
        let list = this.formField.nextElementSibling;
        if (window.location.pathname.includes('/formulaire-contact/')) {
            list = document.querySelector("#city");
        }
        list.innerHTML = "";

        if (data.length > 0) {
            for (const item of data) {
                const option = this.createCommuneOption(item, list, this.formField, this.submit);
                list.appendChild(option);
            }
            new this.ListBehavior();
        } else {
            const noResultOption = this.createNoResultOption();
            list.appendChild(noResultOption);
        }
    }

    createLoadingOption() {

        const option = (window.location.pathname.includes('/formulaire-contact/'))
            ? document.createElement("option")
            : document.createElement("li");
        const text = document.createTextNode("Loading...");
        option.appendChild(text);
        option.classList.add("waiting");
        return option;
    }

    /**
     * Creates a commune option element with the provided data.
     *
     * @param {Object} data - The data object containing the commune information.
     * @param {HTMLElement} list - The list element to which the option will be appended.
     * @param formField
     * @param submit
     * @return {HTMLElement} - The created commune option element.
     */
    createCommuneOption(data, list, formField, submit) {
        const option = (window.location.pathname.includes('/formulaire-contact/'))
            ? document.createElement("option")
            : document.createElement("li");
        const text = document.createTextNode(`${data.ville} (${data.code_postal})`);
        option.appendChild(text);
        let classCommune = (window.location.pathname.includes('/formulaire-contact/')) ? "select" : "commune";
        option.classList.add(classCommune)
        option.value = data.ville;
        option.setAttribute("data-ville", data.ville);
        option.setAttribute("data-code_postal", data.code_postal);
        option.setAttribute("data-code_INSEE", data.code_INSEE);
        option.addEventListener("click", function () {
            if (formField.getAttribute('id') === "form-field-communeHome") {
                StoreLocatorBehavior.RedirectToFicheAgence(data.ville, data.code_postal, data.code_INSEE);
                option.classList.add('hide');
                return;
            }
            if (window.location.pathname.includes('/formulaire-contact/')) {
                option.classList.add('selected');
            } else {
                formField.value = this.getAttribute("data-ville");
                formField.setAttribute("data-ville", this.getAttribute("data-ville"));
                formField.setAttribute("data-code_postal", this.getAttribute("data-code_postal"));
                formField.setAttribute("data-code_INSEE", this.getAttribute("data-code_INSEE"));
                const input = document.querySelector(".input-city");
                input.value = this.getAttribute("data-ville");
                input.setAttribute("data-ville", this.getAttribute("data-ville"));
                input.setAttribute("data-code_postal", this.getAttribute("data-code_postal"));
                input.setAttribute("data-code_INSEE", this.getAttribute("data-code_INSEE"));
                list.innerHTML = "";
            }
        });
        return option;
    }


    /**
     * Creates a new option element with the text "No results" and adds the class "no-result".
     *
     * @return {HTMLLIElement} The newly created option element.
     */
    createNoResultOption() {
        const option = document.createElement("li");
        const text = document.createTextNode("No results");
        option.appendChild(text);
        option.classList.add("no-result");
        return option;
    }

    ListBehavior() {
        tool.waitForElem(".commune").then((elem) => {
            document.addEventListener("keydown", function (e) {
                if (e.key === "Enter") {
                    elem.click();
                }
            });
        });
    }
}


class StoreLocatorBehavior {
    constructor(formField, submit) {
        this.formField = formField;
        this.submit = submit;
        //this.init().then(r => r);
        this.SearchSL(formField, submit);
    }

    static HomeBehavior(submit, formField) {
        let dataVilleExists = formField.hasAttribute("data-ville");
        let dataCodePostalExists = formField.hasAttribute("data-code_postal");
        let dataCodeINSEEExists = formField.hasAttribute("data-code_INSEE");
        if (!dataCodePostalExists && !dataVilleExists && !dataCodeINSEEExists) {
            submit.setAttribute("disabled", "disabled");
            submit.classList.add("disabled");
            submit.style.cursor = "not-allowed";
        } else {
            submit.removeAttribute("disabled");
            submit.style.cursor = "pointer";
            submit.classList.remove("disabled");
        }


        //redirection vers la page index avec les inputs CP + Ville
        submit.addEventListener("click", function () {
            let ville = formField.getAttribute("data-ville");
            let cp = formField.getAttribute("data-code_postal");
            let code_INSEE = formField.getAttribute("data-code_INSEE");
            window.location =
                window.location.origin +
                "/index-des-agences-par-ville/?ville=" +
                ville +
                "&code_postal=" +
                cp +
                "&code_INSEE=" +
                code_INSEE;

            setTimeout(function () {
                formField.value = '';
            }, 3000);
        });
    }

    static RedirectToFicheAgence(ville, code_postal, code_INSEE) {
        let formField = document.querySelector("#form-field-communeHome");
        let submit = document.querySelector("#submit-button");
        formField.value = ville;
        submit.removeAttribute("disabled");
        submit.style.cursor = "pointer";
        submit.classList.remove("disabled");

        submit.addEventListener("click", function () {
            window.location =
                window.location.origin +
                "/index-des-agences-par-ville/?ville=" +
                ville +
                "&code_postal=" +
                code_postal + "&code_INSEE=" + code_INSEE;
        });
    }

    init() {
        this.SearchSL(this.formField, this.submit);
    }

    SearchSL(formField, submit) {
        formField = document.querySelector(formField);
        submit = document.querySelector(submit);

        //si formField n'est pas un input, on cherche le premier input dans le formField
        if (formField.tagName !== "INPUT") {
            formField = formField.querySelector("input");
        }
        if (formField.getAttribute('id') === "form-field-communeHome") {
            StoreLocatorBehavior.HomeBehavior(submit, formField);
        }
        const maxChars = 4;
        if (formField) {
            formField.addEventListener(
                "input",
                tool.throttle(function handleInput(event) {
                    if (this.value.length >= maxChars) {
                        let cp = this.value.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
                        new StoreLocatorSearch(cp, formField, submit);
                    }
                }),
                850
            );
        }
    }
}

export {StoreLocatorBehavior, StoreLocatorSearch};
